import { LocalDate } from '@js-joda/core';

import { NationalIdentificationNumber, Passport, Pesel } from '@dreryk/personal-external-identifier-common-api';

import { createVisitor } from '~libs.typescript';

import { PatientAuthorization } from '../types';

export const patientAuthorizationIdentifierVisitor = createVisitor<
   PatientAuthorization,
   {
      visitBirthDate: LocalDate;
      visitPesel: Pesel;
      visitNationalIdentificationNumber: NationalIdentificationNumber;
      visitPassport: Passport;
   }
>((patientAuthorization, visitor) => {
   if (patientAuthorization.birthDate) {
      return visitor.visitBirthDate?.(patientAuthorization.birthDate);
   }

   if (patientAuthorization.externalIdentifier) {
      return patientAuthorization.externalIdentifier.accept({
         visitPesel: (pesel) => visitor.visitPesel?.(pesel),
         visitPassport: (passport) => visitor.visitPassport?.(passport),
         visitNationalIdentificationNumber: (nationalIdentificationNumber) =>
            visitor.visitNationalIdentificationNumber?.(nationalIdentificationNumber),
      });
   }

   return undefined;
});
